
import React from 'react';

export const Error = ({ error }) => {
    //console.log( error);
    return <div className="alert alert-danger m-2">
        Sorry, an error occurred {error && error.statusText ? " - " + error.statusText : ""}

    </div>
}